import BaseComponent from './BaseComponent';

class InputSubmit extends BaseComponent {
  constructor(componentName, autoInit){
    super(componentName);
  }


  init(component) {
    this.addCustomEvents(component);
  }


  addCustomEvents(component) {
    const element = component.element;
    element.addEventListener('click', (e) => {
      app.components.form.submitData(element, false, true);
    })
  }
}

export default InputSubmit;
